import React from 'react';

// Services
import { getTranslateByKey } from '@/main/services/utils';

// Components
import Button from '@/main/components/shared/button/button';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

// Components/Styles Local
import * as S from './styles';

interface IModalConfirmDelete {
  titleModal: string;
  handleModalCancel: () => void;
  handleModalConfirm: () => void;
}

function ModalConfirm({
  titleModal,
  handleModalCancel,
  handleModalConfirm
}: IModalConfirmDelete) {
  return (
    <S.BoxModal>
      {titleModal && <S.TitleModal>{titleModal}</S.TitleModal>}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '1rem',
          gap: '1rem'
        }}>
        <SecondaryButton type="button" onClick={() => handleModalCancel()}>
          {getTranslateByKey('information.no')}
        </SecondaryButton>
        <Button type="button" onClick={() => handleModalConfirm()} >
          {getTranslateByKey('information.yes')}
        </Button>
      </div>
    </S.BoxModal>
  );
}

export default ModalConfirm;
